export const ACCEPT_ACTION = "accepted";
export const DECLINE_ACTION = "declined";
export const CHAT_ACTION = "chat";
export const FLAG_ACTION = "flag";
export const CONTACT_CLIENT_ACTION = "contact"; // problematic with the status. need to know which one to use.
export const SUBMIT_FEEDBACK_ACTION = "feedback";
export const VIEW_CALL_TIPS_ACTION = "call_tips";
export const BOOK_LESSONS_ACTION = "book_lessons";
export const SHOW_EARNINGS_ACTION = "show_earnings";

export const PENDING_RESPONSE = "pending";
export const ACCEPTED_RESPONSE = "accepted";
export const DECLINED_RESPONSE = "declined";
export const NO_RESPONSE = "no_response";
export const APPLIED_RESPONSE = "applied";
export const REPLACED_RESPONSE = "replaced";

export const ISSUED_REQUEST_STATUS = "issued";
export const COMPLETED_REQUEST_STATUS = "completed";
export const PENDING_REQUEST_STATUS = "pending";
export const PROSPECTIVE_REQUEST_STATUS = "prospective_client";
export const CANCELED_REQUEST_STATUS = "cold";
export const PAID_SPEAKING_FEE_STATUS = "request_to_meet";
export const PAID_LESSON_FEE_STATUS = "payed";
export const BOOKED_LESSONS_STATUS = "booked";
export const CLIENT_UNREACHABLE_STATUS = "not_reachable";
export const CANT_AFFORD_PRICE_STATUS = "cant_afford_price";
export const CLIENT_UNDECIDED_STATUS = "found_manually";
export const NO_AVAILABLE_TUTOR_STATUS = "book_later";

export const LOST_REQUESTS_STATUS = [
  CANCELED_REQUEST_STATUS,
  CLIENT_UNREACHABLE_STATUS,
  CANT_AFFORD_PRICE_STATUS,
  CLIENT_UNDECIDED_STATUS,
  NO_AVAILABLE_TUTOR_STATUS,
];

export const DEGREE_DATA = [
  { name: "Diploma Certificate", abbrev: "Dipl.", rank: 2 },
  { name: "National Certificate of Education", abbrev: "NCE", rank: 3 },
  { name: "Ordinary National Diploma", abbrev: "OND", rank: 2 },
  { name: "Higher National Diploma", abbrev: "HND", rank: 3 },
  { name: "Bachelor of Science", abbrev: "B.Sc", rank: 3 },
  { name: "Bachelor of Education", abbrev: "B.Ed", rank: 3 },
  { name: "Bachelor of Laws", abbrev: "LL.B", rank: 3 },
  { name: "Bachelor of Technology", abbrev: "B.Tech", rank: 3 },
  { name: "Bachelor of Arts", abbrev: "B.A", rank: 3 },
  { name: "Bachelor of Engineering", abbrev: "B.Eng", rank: 3 },
  { name: "Bachelor of Medicine & Surgery", abbrev: "MBBS", rank: 3 },
  { name: "Post-graduate Diploma in Education", abbrev: "PGDE", rank: 3 },
  { name: "Master of Arts", abbrev: "M.A", rank: 4 },
  { name: "Master of Education", abbrev: "M.Ed", rank: 4 },
  { name: "Master of Science", abbrev: "M.Sc", rank: 4 },
  { name: "Master of Laws", abbrev: "LL.M", rank: 4 },
  { name: "Master of Business Administration", abbrev: "MBA", rank: 4 },
  { name: "Doctor of Philosophy", abbrev: "PhD", rank: 5 },
  { name: "Doctor of Education.", abbrev: "Ed.D", rank: 5 },
  { name: "Doctor of Medicine", abbrev: "MD", rank: 5 },
];

export const GRADE_DATA = [
  "First Class",
  "Upper Second Class",
  "Lower Second Class",
  "Summa Cum Laude",
  "Magna Cum Laude",
  "Other grade",
  "Not applicable",
];

export const SCHEDULE_DATA = {
  emptySchedule: {
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  },
  daysOfTheWeek: [
    {
      day: "Mon",
      shortDay: "Mon",
      longDay: "Monday",
      value: "Monday",
      index: 1,
    },
    {
      day: "Tue",
      shortDay: "Tue",
      longDay: "Tuesday",
      value: "Tuesday",
      index: 2,
    },
    {
      day: "Wed",
      shortDay: "Wed",
      longDay: "Wednesday",
      value: "Wednesday",
      index: 3,
    },
    {
      day: "Thu",
      shortDay: "Thu",
      longDay: "Thursday",
      value: "Thursday",
      index: 4,
    },
    {
      day: "Fri",
      shortDay: "Fri",
      longDay: "Friday",
      value: "Friday",
      index: 5,
    },
    {
      day: "Sat",
      shortDay: "Sat",
      longDay: "Saturday",
      value: "Saturday",
      index: 6,
    },
    {
      day: "Sun",
      shortDay: "Sun",
      longDay: "Sunday",
      value: "Sunday",
      index: 0,
    },
  ],
  monthsOfTheYear: [
    { longName: "January", shortName: "Jan" },
    { longName: "February", shortName: "Feb" },
    { longName: "March", shortName: "Mar" },
    { longName: "April", shortName: "Apr" },
    { longName: "May", shortName: "May" },
    { longName: "June", shortName: "Jun" },
    { longName: "July", shortName: "Jul" },
    { longName: "August", shortName: "Aug" },
    { longName: "September", shortName: "Sep" },
    { longName: "October", shortName: "Oct" },
    { longName: "November", shortName: "Nov" },
    { longName: "December", shortName: "Dec" },
  ],
  timeOfDay: [
    {
      label: "Before 12pm",
      value: "Morning",
    },
    {
      label: "12 - 5pm",
      value: "Afternoon",
    },
    {
      label: "After 5pm",
      value: "Evening",
    },
  ],
  timeRange: [
    {
      range: "Morning",
      description: "6 - 9am",
      times: [6, 7, 8, 9],
      icon: "dawn",
    },
    {
      range: "Late morning",
      description: "9 - 12pm",
      times: [9, 10, 11, 12],
      icon: "morning",
    },
    {
      range: "Afternoon",
      description: "12 - 3pm",
      times: [12, 13, 14, 15],
      icon: "afternoon",
    },
    {
      range: "Late afternoon",
      description: "3 - 6pm",
      icon: "sunset",
      times: [15, 16, 17, 18],
    },
    {
      range: "Evening",
      description: "6 - 9pm",
      times: [18, 19, 20, 21],
      icon: "evening",
    },
    {
      range: "Late evening",
      description: "9 - 12am",
      icon: "late-evening",
      times: [21, 22, 23, 24],
    },
    {
      range: "Night",
      description: "0 - 3am",
      times: [0, 1, 2, 3],
      icon: "night-time",
    },
    {
      range: "Late night",
      description: "3 - 6am",
      icon: "sunrise",
      times: [3, 4, 5, 6],
    },
  ],
  mapPeriodToTime: {
    Morning: ["6:00 AM", "6:30 AM", "7:00 AM", "7:30 AM", "8:00 AM", "8:30 AM"],
    "Late morning": [
      "9:00 AM",
      "9.30 AM",
      "10:00 AM",
      "10:30 AM",
      "11:00 AM",
      "11:30 AM",
    ],
    Afternoon: [
      "12:00 PM",
      "12:30 PM",
      "1:00 PM",
      "1:30 PM",
      "2:00 PM",
      "2:30 PM",
    ],
    "Late afternoon": [
      "3:00 PM",
      "3:30 PM",
      "4:00 PM",
      "4:30 PM",
      "5:00 PM",
      "5:30 PM",
    ],
    Evening: ["6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM"],
    "Late evening": [
      "9:00 PM",
      "9:30 PM",
      "10:00 PM",
      "10:30 PM",
      "11:00 PM",
      "11:30 PM",
    ],
    Night: [
      "00:00 AM",
      "00:30 AM",
      "01:00 AM",
      "01:30 AM",
      "02:00 AM",
      "02:30 AM",
    ],
    "Late night": [
      "03:00 AM",
      "03:30 AM",
      "04:00 AM",
      "04:30 AM",
      "05:00 AM",
      "05:30 AM",
    ],
  },
  hourlyTimes: [
    "6:00 AM",
    "6:30 AM",
    "7:00 AM",
    "7:30 AM",
    "8:00 AM",
    "8:30 AM",
    "9:00 AM",
    "9.30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "1:00 PM",
    "1:30 PM",
    "2:00 PM",
    "2:30 PM",
    "3:00 PM",
    "3:30 PM",
    "4:00 PM",
    "4:30 PM",
    "5:00 PM",
    "5:30 PM",
    "6:00 PM",
    "6:30 PM",
    "7:00 PM",
    "7:30 PM",
    "8:00 PM",
    "8:30 PM",
    "9:00 PM",
    "9:30 PM",
    "10:00 PM",
  ],
  durationOfLesson: [
    {
      label: "1 week",
      value: 1,
    },
    {
      label: "2 weeks",
      value: 2,
    },
    {
      label: "3 weeks",
      value: 3,
    },
    {
      label: "Monthly",
      value: 4,
    },
  ],
  hoursOfLesson: [
    {
      label: "1 hour",
      value: 1,
    },
    { label: "1.5 hours", value: 1.5 },
    {
      label: "2 hours",
      value: 2,
    },
    {
      label: "2.5 hours",
      value: 2.5,
    },
    {
      label: "3 hours",
      value: 3,
    },
    {
      label: "4 hours",
      value: 4,
    },
    {
      label: "5 hours",
      value: 5,
    },
    {
      label: "6 hours",
      value: 6,
    },
  ],
  lessonUrgency: [
    {
      label: "Immediately",
      value: "Immediately",
    },
    {
      label: "In a few days",
      value: "In a few days",
    },
    {
      label: "In a few weeks",
      value: "In a few weeks",
    },
    {
      label: "Not yet sure",
      value: "At an agreed date",
    },
  ],
  lessonsPerWeek: [
    { value: 1, label: "1 day/wk" },
    { value: 2, label: "2 days/wk" },
    { value: 3, label: "3 days/wk" },
    { value: 4, label: "4 days/wk" },
    { value: 5, label: "5 days/wk" },
    { value: 6, label: "6 days/wk" },
    { value: 7, label: "7 days/wk" },
  ],
};

export const TUTERIA_MAPPINGS = [
  {
    tuteria_subjects: "Literacy & Numeracy",
    mappings: ["Literacy & Numeracy"],
  },
  {
    tuteria_subjects: "Creative Writing",
    mappings: ["Creative Writing"],
  },
  {
    tuteria_subjects: "Phonics",
    mappings: ["Phonics"],
  },
  {
    tuteria_subjects: "Basic Mathematics",
    mappings: [
      "Primary Math",
      "School Entrance Math",
      "11+ Math",
      "11+ Non-verbal",
      "Primary Checkpoint Math",
    ],
  },
  {
    tuteria_subjects: "Handwriting Improvement",
    mappings: ["Handwriting"],
  },
  {
    tuteria_subjects: "History",
    mappings: [
      "History",
      "13+ History",
      "IGCSE History",
      "Edexcel History",
      "IB History",
    ],
  },
  {
    tuteria_subjects: "Spanish Language",
    mappings: [
      "13+ Spanish",
      "IGCSE Spanish",
      "Edexcel Spanish",
      "SAT Spanish",
      "AP Spanish",
    ],
  },
  {
    tuteria_subjects: "French Language",
    mappings: [
      "13+ French",
      "IGCSE French",
      "Edexcel French",
      "SAT French",
      "AP French",
    ],
  },
  {
    tuteria_subjects: "German Language",
    mappings: [
      "13+ German",
      "IGCSE German",
      "Edexcel German",
      "SAT German",
      "AP German",
    ],
  },
  {
    tuteria_subjects: "English Language",
    mappings: [
      "Primary English",
      "School Entrance English",
      "11+ English",
      "Primary Checkpoint English",
      "JSS English",
      "Checkpoint English",
      "13+ English",
      "SSS English",
      "IGCSE English",
      "ACT English",
      "Edexcel Biology",
      "IB English",
      "AP English",
    ],
  },
  {
    tuteria_subjects: "Basic Sciences",
    mappings: [
      "Primary Science",
      "Primary Checkpoint Science",
      "JSS Science",
      "Checkpoint Science",
      "13+ Science",
    ],
  },
  {
    tuteria_subjects: "Geography",
    mappings: [
      "Geography",
      "13+ Geography",
      "IGCSE Geography",
      "Edexcel Geography",
      "IB Geography",
      "AP Geography",
    ],
  },
  {
    tuteria_subjects: "Computer Science",
    mappings: ["ICT", "Edexcel ICT"],
  },
  {
    tuteria_subjects: "Social Studies",
    mappings: [""],
  },
  {
    tuteria_subjects: "Basic Technology",
    mappings: ["Technology"],
  },
  {
    tuteria_subjects: "Agricultural Science",
    mappings: ["Agric. Science"],
  },
  {
    tuteria_subjects: "General Mathematics",
    mappings: [
      "SSS Math",
      "13+ Math",
      "Checkpoint Math",
      "JSS Math",
      "IGCSE Math",
      "Edexcel Math",
      "IB Math",
    ],
  },
  {
    tuteria_subjects: "Physics",
    mappings: [
      "Physics",
      "IGCSE Physics",
      "Edexcel Physics",
      "SAT Physics",
      "IB Physics",
      "AP Physics",
      "ACT Science",
    ],
  },
  {
    tuteria_subjects: "Chemistry",
    mappings: [
      "Chemistry",
      "IGCSE Chemistry",
      "Edexcel Chemistry",
      "SAT Chemistry",
      "IB Chemistry",
      "AP Chemistry",
      "ACT Science",
    ],
  },
  {
    tuteria_subjects: "Biology",
    mappings: [
      "Biology",
      "IGCSE Biology",
      "Edexcel Biology",
      "SAT History",
      "IB Biology",
      "ACT Science",
    ],
  },
  {
    tuteria_subjects: "Technical Drawing",
    mappings: ["Technical Drawing"],
  },
  {
    tuteria_subjects: "Commerce",
    mappings: ["Commerce"],
  },
  {
    tuteria_subjects: "Government",
    mappings: ["Government"],
  },
  {
    tuteria_subjects: "Economics",
    mappings: [
      "Economics",
      "Edexcel Economics",
      "IB Economics",
      "IGCSE Business",
    ],
  },
  {
    tuteria_subjects: "Further Mathematics",
    mappings: [
      "F/Math",
      "AP Calculus",
      "AP Statistics",
      "SAT Math I",
      "SAT Math II",
    ],
  },
  {
    tuteria_subjects: "Principles of Accounting",
    mappings: ["Accounting", "Edexcel Accounting"],
  },
  {
    tuteria_subjects: "Literature in English",
    mappings: [
      "Literature",
      "IGCSE Literature",
      "Edexcel Literature",
      "SAT Literature",
      "AP Literature",
    ],
  },
  {
    tuteria_subjects: "TOEFL",
    mappings: ["TOEFL"],
  },
  {
    tuteria_subjects: "IELTS",
    mappings: ["IELTS"],
  },
  {
    tuteria_subjects: "SAT Math",
    mappings: ["SAT Math", "ACT Math"],
  },
  {
    tuteria_subjects: "SAT Reading",
    mappings: ["SAT Reading", "ACT English", "ACT Reading"],
  },
  {
    tuteria_subjects: "SAT Writing",
    mappings: ["SAT Writing", "ACT Writing"],
  },
  {
    tuteria_subjects: "Arabic Language",
    mappings: ["Edexcel Arabic"],
  },
  {
    tuteria_subjects: "Business Studies",
    mappings: ["Business Studies", "Edexcel Business"],
  },
  {
    tuteria_subjects: "World History",
    mappings: ["SAT U.S. History", "AP U.S. History"],
  },
  {
    tuteria_subjects: "Chinese Language",
    mappings: ["SAT Chinese", "AP Chinese"],
  },
  {
    tuteria_subjects: "Music Theory",
    mappings: ["AP Music"],
  },
];

export const ACADEMICS_DATA = {
  Preschool: {
    purposes: [
      {
        name: "Early Child Education",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Literacy & Numeracy",
            shortName: "Literacy & Numeracy",
            isPreselected: true,
          },
          {
            name: "Phonics",
            shortName: "Phonics",
            isPreselected: true,
          },
          {
            name: "Handwriting Improvement",
            shortName: "Handwriting",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "Nursery 1": {
    purposes: [
      {
        name: "Early Child Education",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Literacy & Numeracy",
            shortName: "Literacy & Numeracy",
            isPreselected: true,
          },
          {
            name: "Phonics",
            shortName: "Phonics",
            isPreselected: true,
          },
          {
            name: "Handwriting Improvement",
            shortName: "Handwriting",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "Nursery 2": {
    purposes: [
      {
        name: "Early Child Education",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Literacy & Numeracy",
            shortName: "Literacy & Numeracy",
            isPreselected: true,
          },
          {
            name: "Phonics",
            shortName: "Phonics",
            isPreselected: true,
          },
          {
            name: "Handwriting Improvement",
            shortName: "Handwriting",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "Primary 1": {
    purposes: [
      {
        name: "Lower Primary Education",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "Primary English",
            isPreselected: true,
          },
          {
            name: "Basic Sciences",
            shortName: "Primary Science",
            isPreselected: false,
          },
          {
            name: "Creative Writing",
            shortName: "Creative Writing",
            isPreselected: false,
          },
          {
            name: "Phonics",
            shortName: "Phonics",
            isPreselected: false,
          },
          {
            name: "Handwriting Improvement",
            shortName: "Handwriting",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "Primary 2": {
    purposes: [
      {
        name: "Lower Primary Education",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "Primary English",
            isPreselected: true,
          },
          {
            name: "Basic Sciences",
            shortName: "Primary Science",
            isPreselected: false,
          },
          {
            name: "Creative Writing",
            shortName: "Creative Writing",
            isPreselected: false,
          },
          {
            name: "Phonics",
            shortName: "Phonics",
            isPreselected: false,
          },
          {
            name: "Handwriting Improvement",
            shortName: "Handwriting",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "Primary 3": {
    purposes: [
      {
        name: "Lower Primary Education",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "Primary English",
            isPreselected: true,
          },
          {
            name: "Basic Sciences",
            shortName: "Primary Science",
            isPreselected: false,
          },
          {
            name: "Creative Writing",
            shortName: "Creative Writing",
            isPreselected: false,
          },
          {
            name: "Phonics",
            shortName: "Phonics",
            isPreselected: false,
          },
          {
            name: "Handwriting Improvement",
            shortName: "Handwriting",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "Primary 4": {
    purposes: [
      {
        name: "General Home Lessons",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "Primary English",
            isPreselected: true,
          },
          {
            name: "Basic Sciences",
            shortName: "Primary Science",
            isPreselected: false,
          },
          {
            name: "Creative Writing",
            shortName: "Creative Writing",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
        ],
      },
      {
        name: "Common Entrance Exam",
        description: "National entrance exam prep",
        subjects: [
          {
            name: "Common Entrance Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "Common Entrance English",
            shortName: "Primary English",
            isPreselected: true,
          },
          // {
          //   name: "General Knowledge",
          //   shortName: "General Knowledge",
          //   isPreselected: true,
          // },
        ],
      },
      {
        name: "Entrance Into Top Schools",
        description: "Like Loyola, Grange, Regent, BIS etc.",
        subjects: [
          {
            name: "School Entrance Mathematics",
            shortName: "School Entrance Math",
            isPreselected: true,
          },
          {
            name: "School Entrance English",
            shortName: "School Entrance English",
            isPreselected: true,
          },
          // {
          //   name: "General Knowledge",
          //   shortName: "General Knowledge",
          //   isPreselected: true,
          // },
        ],
      },
    ],
  },
  "Primary 5": {
    purposes: [
      {
        name: "General Home Lessons",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "Primary English",
            isPreselected: true,
          },
          {
            name: "Basic Sciences",
            shortName: "Primary Science",
            isPreselected: false,
          },
          {
            name: "Creative Writing",
            shortName: "Creative Writing",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
        ],
      },
      {
        name: "Common Entrance Exam",
        description: "National entrance exam prep",
        subjects: [
          {
            name: "Common Entrance Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "Common Entrance English",
            shortName: "Primary English",
            isPreselected: true,
          },
          // {
          //   name: "General Knowledge",
          //   shortName: "General Knowledge",
          //   isPreselected: true,
          // },
        ],
      },
      {
        name: "Entrance Into Top Schools",
        description: "Like Loyola, Grange, Regent, BIS etc.",
        subjects: [
          {
            name: "School Entrance Mathematics",
            shortName: "School Entrance Math",
            isPreselected: true,
          },
          {
            name: "School Entrance English",
            shortName: "School Entrance English",
            isPreselected: true,
          },
          // {
          //   name: "General Knowledge",
          //   shortName: "General Knowledge",
          //   isPreselected: true,
          // },
        ],
      },
      {
        name: "11+ Entrance Exam",
        description: "Entrance exam into UK schools",
        subjects: [
          {
            name: "11+ Mathematics",
            shortName: "11+ Math",
            isPreselected: true,
          },
          {
            name: "11+ English Language",
            shortName: "11+ English",
            isPreselected: true,
          },
          {
            name: "11+ Verbal Reasoning",
            shortName: "11+ Verbal",
            isPreselected: true,
          },
          {
            name: "11+ Non-verbal Reasoning",
            shortName: "11+ Non-verbal",
            isPreselected: true,
          },
        ],
      },
      {
        name: "Cambridge Primary Exam",
        description: "International Checkpoint exam",
        subjects: [
          {
            name: "Primary Checkpoint Math",
            shortName: "Primary Checkpoint Math",
            isPreselected: true,
          },
          {
            name: "Primary Checkpoint English",
            shortName: "Primary Checkpoint English",
            isPreselected: true,
          },
          {
            name: "Primary Checkpoint Science",
            shortName: "Primary Checkpoint Science",
            isPreselected: true,
          },
        ],
      },
    ],
  },
  "Primary 6": {
    purposes: [
      {
        name: "Common Entrance Exam",
        description: "National entrance exam prep",
        subjects: [
          {
            name: "Common Entrance Mathematics",
            shortName: "Primary Math",
            isPreselected: true,
          },
          {
            name: "Common Entrance English",
            shortName: "Primary English",
            isPreselected: true,
          },
          // {
          //   name: "General Knowledge",
          //   shortName: "General Knowledge",
          //   isPreselected: true,
          // },
        ],
      },
      {
        name: "Entrance Into Top Schools",
        description: "Like Loyola, Grange, Regent, BIS etc.",
        subjects: [
          {
            name: "School Entrance Mathematics",
            shortName: "School Entrance Math",
            isPreselected: true,
          },
          {
            name: "School Entrance English",
            shortName: "School Entrance English",
            isPreselected: true,
          },
          // {
          //   name: "General Knowledge",
          //   shortName: "General Knowledge",
          //   isPreselected: true,
          // },
        ],
      },
      {
        name: "11+ Entrance Exam",
        description: "Entrance exam into UK schools",
        subjects: [
          {
            name: "11+ Mathematics",
            shortName: "11+ Math",
            isPreselected: true,
          },
          {
            name: "11+ English Language",
            shortName: "11+ English",
            isPreselected: true,
          },
          {
            name: "11+ Verbal Reasoning",
            shortName: "11+ Verbal",
            isPreselected: true,
          },
          {
            name: "11+ Non-verbal Reasoning",
            shortName: "11+ Non-verbal",
            isPreselected: true,
          },
        ],
      },
      {
        name: "Cambridge Primary Exam",
        description: "International Checkpoint exam",
        subjects: [
          {
            name: "Primary Checkpoint Math",
            shortName: "Primary Checkpoint Math",
            isPreselected: true,
          },
          {
            name: "Primary Checkpoint English",
            shortName: "Primary Checkpoint English",
            isPreselected: true,
          },
          {
            name: "Primary Checkpoint Science",
            shortName: "Primary Checkpoint Science",
            isPreselected: true,
          },
        ],
      },
    ],
  },
  "JSS 1": {
    purposes: [
      {
        name: "General Home Lessons",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "JSS Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "JSS English",
            isPreselected: true,
          },
          {
            name: "Science",
            shortName: "JSS Science",
            isPreselected: false,
          },
          {
            name: "Business Studies",
            shortName: "Business Studies",
            isPreselected: false,
          },
          {
            name: "Technology",
            shortName: "Technology",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "JSS 2": {
    purposes: [
      {
        name: "General Home Lessons",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "JSS Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "JSS English",
            isPreselected: true,
          },
          {
            name: "Science",
            shortName: "JSS Science",
            isPreselected: false,
          },
          {
            name: "Business Studies",
            shortName: "Business Studies",
            isPreselected: false,
          },
          {
            name: "Technology",
            shortName: "Technology",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
        ],
      },
      {
        name: "Cambridge Checkpoint",
        description: "Prepare for Checkpoints exam",
        subjects: [
          {
            name: "Checkpoint Mathematics",
            shortName: "Checkpoint Math",
            isPreselected: true,
          },
          {
            name: "Checkpoint English Language",
            shortName: "Checkpoint English",
            isPreselected: true,
          },
          {
            name: "Checkpoint Science",
            shortName: "Checkpoint Science",
            isPreselected: true,
          },
        ],
      },
    ],
  },
  "JSS 3": {
    purposes: [
      {
        name: "General Home Lessons",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "JSS Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "JSS English",
            isPreselected: true,
          },
          {
            name: "Science",
            shortName: "JSS Science",
            isPreselected: false,
          },
          {
            name: "Business Studies",
            shortName: "Business Studies",
            isPreselected: false,
          },
          {
            name: "Technology",
            shortName: "Technology",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
        ],
      },
      {
        name: "JSSCE / BECE",
        description: "Prep for JSS3 certificate exam",
        subjects: [
          {
            name: "Mathematics",
            shortName: "JSS Math",
            isPreselected: true,
          },
          {
            name: "English Language",
            shortName: "JSS English",
            isPreselected: true,
          },
          {
            name: "Science",
            shortName: "JSS Science",
            isPreselected: false,
          },
          {
            name: "Business Studies",
            shortName: "Business Studies",
            isPreselected: false,
          },
          {
            name: "Technology",
            shortName: "Technology",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
        ],
      },
      {
        name: "Cambridge Checkpoint",
        description: "Prepare for Checkpoints exam",
        subjects: [
          {
            name: "Checkpoint Mathematics",
            shortName: "Checkpoint Math",
            isPreselected: true,
          },
          {
            name: "Checkpoint English Language",
            shortName: "Checkpoint English",
            isPreselected: true,
          },
          {
            name: "Checkpoint Science",
            shortName: "Checkpoint Science",
            isPreselected: true,
          },
        ],
      },
      {
        name: "13+ Entrance Exam",
        description: "Entrance into UK senior schools",
        subjects: [
          {
            name: "13+ Mathematics",
            shortName: "13+ Math",
            isPreselected: true,
          },
          {
            name: "13+ English Language",
            shortName: "13+ English",
            isPreselected: true,
          },
          {
            name: "13+ Science",
            shortName: "13+ Science",
            isPreselected: true,
          },
          {
            name: "13+ Geography",
            shortName: "13+ Geography",
            isPreselected: false,
          },
          {
            name: "13+ History",
            shortName: "13+ History",
            isPreselected: false,
          },
          {
            name: "13+ Spanish",
            shortName: "13+ Spanish",
            isPreselected: false,
          },
          {
            name: "13+ French",
            shortName: "13+ French",
            isPreselected: false,
          },
          {
            name: "13+ German",
            shortName: "13+ German",
            isPreselected: false,
          },
          // {
          //   name: "13+ Classical Greek",
          //   shortName: "13+ Greek",
          //   isPreselected: false,
          // },
          // {
          //   name: "13+ Latin",
          //   shortName: "13+ Latin",
          //   isPreselected: false,
          // },
        ],
      },
    ],
  },
  "SSS 1": {
    purposes: [
      {
        name: "General Home Lessons",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "SSS Math",
            isPreselected: false,
          },
          {
            name: "English Language",
            shortName: "SSS English",
            isPreselected: false,
          },
          {
            name: "Physics",
            shortName: "Physics",
            isPreselected: false,
          },
          {
            name: "Chemistry",
            shortName: "Chemistry",
            isPreselected: false,
          },
          {
            name: "Biology",
            shortName: "Biology",
            isPreselected: false,
          },
          {
            name: "Further Mathematics",
            shortName: "F/Math",
            isPreselected: false,
          },
          {
            name: "Economics",
            shortName: "Economics",
            isPreselected: false,
          },
          {
            name: "Accounting",
            shortName: "Accounting",
            isPreselected: false,
          },
          {
            name: "English Literature",
            shortName: "Literature",
            isPreselected: false,
          },
          {
            name: "Government",
            shortName: "Government",
            isPreselected: false,
          },
          {
            name: "Commerce",
            shortName: "Commerce",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Technical Drawing",
            shortName: "Technical Drawing",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "SSS 2": {
    purposes: [
      {
        name: "General Home Lessons",
        description: "Homework, revision, study help",
        subjects: [
          {
            name: "Mathematics",
            shortName: "SSS Math",
            isPreselected: false,
          },
          {
            name: "English Language",
            shortName: "SSS English",
            isPreselected: false,
          },
          {
            name: "Physics",
            shortName: "Physics",
            isPreselected: false,
          },
          {
            name: "Chemistry",
            shortName: "Chemistry",
            isPreselected: false,
          },
          {
            name: "Biology",
            shortName: "Biology",
            isPreselected: false,
          },
          {
            name: "Further Mathematics",
            shortName: "F/Math",
            isPreselected: false,
          },
          {
            name: "Economics",
            shortName: "Economics",
            isPreselected: false,
          },
          {
            name: "Accounting",
            shortName: "Accounting",
            isPreselected: false,
          },
          {
            name: "English Literature",
            shortName: "Literature",
            isPreselected: false,
          },
          {
            name: "Government",
            shortName: "Government",
            isPreselected: false,
          },
          {
            name: "Commerce",
            shortName: "Commerce",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Technical Drawing",
            shortName: "Technical Drawing",
            isPreselected: false,
          },
        ],
      },
      {
        name: "WAEC / UME / NECO / JUPEB",
        description: "Senior certificate examinations",
        subjects: [
          {
            name: "Mathematics",
            shortName: "SSS Math",
            isPreselected: false,
          },
          {
            name: "English Language",
            shortName: "SSS English",
            isPreselected: false,
          },
          {
            name: "Physics",
            shortName: "Physics",
            isPreselected: false,
          },
          {
            name: "Chemistry",
            shortName: "Chemistry",
            isPreselected: false,
          },
          {
            name: "Biology",
            shortName: "Biology",
            isPreselected: false,
          },
          {
            name: "Further Mathematics",
            shortName: "F/Math",
            isPreselected: false,
          },
          {
            name: "Economics",
            shortName: "Economics",
            isPreselected: false,
          },
          {
            name: "Accounting",
            shortName: "Accounting",
            isPreselected: false,
          },
          {
            name: "English Literature",
            shortName: "Literature",
            isPreselected: false,
          },
          {
            name: "Government",
            shortName: "Government",
            isPreselected: false,
          },
          {
            name: "Commerce",
            shortName: "Commerce",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Technical Drawing",
            shortName: "Technical Drawing",
            isPreselected: false,
          },
        ],
      },
      {
        name: "IGCSE - Cambridge A/Levels",
        description: "Preparation for the IGCSEs",
        subjects: [
          {
            name: "IGCSE Mathematics",
            shortName: "IGCSE Math",
            isPreselected: false,
          },
          {
            name: "IGCSE English Language",
            shortName: "IGCSE English",
            isPreselected: false,
          },
          {
            name: "IGCSE English Literature",
            shortName: "IGCSE Literature",
            isPreselected: false,
          },
          {
            name: "IGCSE Biology",
            shortName: "IGCSE Biology",
            isPreselected: false,
          },
          {
            name: "IGCSE Chemistry",
            shortName: "IGCSE Chemistry",
            isPreselected: false,
          },
          {
            name: "IGCSE Physics",
            shortName: "IGCSE Physics",
            isPreselected: false,
          },
          {
            name: "IGCSE Geography",
            shortName: "IGCSE Geography",
            isPreselected: false,
          },
          {
            name: "IGCSE Spanish",
            shortName: "IGCSE Spanish",
            isPreselected: false,
          },
          {
            name: "IGCSE History",
            shortName: "IGCSE History",
            isPreselected: false,
          },
          {
            name: "IGCSE Computer Science",
            shortName: "IGCSE Computer",
            isPreselected: false,
          },
          {
            name: "IGCSE French",
            shortName: "IGCSE French",
            isPreselected: false,
          },
          {
            name: "IGCSE German",
            shortName: "IGCSE German",
            isPreselected: false,
          },
          {
            name: "IGCSE Business",
            shortName: "IGCSE Business",
            isPreselected: false,
          },
        ],
      },
      {
        name: "SAT / PSAT - Reasoning Test",
        description: "Math, Reading & Writing",
        subjects: [
          {
            name: "SAT Math",
            shortName: "SAT Math",
            isPreselected: true,
          },
          {
            name: "SAT Reading",
            shortName: "SAT Reading",
            isPreselected: true,
          },
          {
            name: "SAT Writing",
            shortName: "SAT Writing",
            isPreselected: true,
          },
        ],
      },
      {
        name: "ACT - College Test",
        description: "Math, English, Reading & Science",
        subjects: [
          {
            name: "ACT Mathematics",
            shortName: "ACT Math",
            isPreselected: true,
          },
          {
            name: "ACT English",
            shortName: "ACT English",
            isPreselected: true,
          },
          {
            name: "ACT Science",
            shortName: "ACT Science",
            isPreselected: true,
          },
          {
            name: "ACT Reading",
            shortName: "ACT Reading",
            isPreselected: true,
          },
          {
            name: "ACT Writing",
            shortName: "ACT Writing",
            isPreselected: false,
          },
        ],
      },
      {
        name: "Test of English Exams",
        description: "IELTS or TOEFL prep",
        subjects: [
          {
            name: "IELTS - International English Test",
            shortName: "IELTS",
            isPreselected: false,
          },
          {
            name: "TOEFL - Test of English",
            shortName: "TOEFL",
            isPreselected: false,
          },
          // {
          //   name: "PTE - Pearson Test of English",
          //   shortName: "PTE",
          //   isPreselected: false,
          // },
        ],
      },
      {
        name: "Edexcel - International A/Levels",
        description: "Pearson's Edexcel exam prep",
        subjects: [
          {
            name: "Edexcel Mathematics",
            shortName: "Edexcel Math",
            isPreselected: false,
          },
          {
            name: "Edexcel English",
            shortName: "Edexcel English",
            isPreselected: false,
          },
          {
            name: "Edexcel Chemistry",
            shortName: "Edexcel Chemistry",
            isPreselected: false,
          },
          {
            name: "Edexcel Economics",
            shortName: "Edexcel Economics",
            isPreselected: false,
          },
          {
            name: "Edexcel Biology",
            shortName: "Edexcel Biology",
            isPreselected: false,
          },
          {
            name: "Edexcel Physics",
            shortName: "Edexcel Physics",
            isPreselected: false,
          },
          {
            name: "Edexcel Accounting",
            shortName: "Edexcel Accounting",
            isPreselected: false,
          },
          {
            name: "Edexcel Applied ICT",
            shortName: "Edexcel ICT",
            isPreselected: false,
          },
          {
            name: "Edexcel Arabic Language",
            shortName: "Edexcel Arabic",
            isPreselected: false,
          },
          {
            name: "Edexcel Business Studies",
            shortName: "Edexcel Business",
            isPreselected: false,
          },
          {
            name: "Edexcel English Literature",
            shortName: "Edexcel Literature",
            isPreselected: false,
          },
          {
            name: "Edexcel French",
            shortName: "Edexcel French",
            isPreselected: false,
          },
          {
            name: "Edexcel Geography",
            shortName: "Edexcel Geography",
            isPreselected: false,
          },
          {
            name: "Edexcel German",
            shortName: "Edexcel German",
            isPreselected: false,
          },
          // {
          //   name: "Edexcel Greek",
          //   shortName: "Edexcel Greek",
          //   isPreselected: false,
          // },
          {
            name: "Edexcel History",
            shortName: "Edexcel History",
            isPreselected: false,
          },
          {
            name: "Edexcel Spanish",
            shortName: "Edexcel Spanish",
            isPreselected: false,
          },
        ],
      },
      {
        name: "SAT II - Subject Tests",
        description: "Prepare for SAT subject tests",
        subjects: [
          {
            name: "SAT Math Level I",
            shortName: "SAT Math I",
            isPreselected: false,
          },
          {
            name: "SAT Math Level II",
            shortName: "SAT Math II",
            isPreselected: false,
          },
          {
            name: "SAT Biology",
            shortName: "SAT Biology",
            isPreselected: false,
          },
          {
            name: "SAT Chemistry",
            shortName: "SAT Chemistry",
            isPreselected: false,
          },
          {
            name: "SAT Physics",
            shortName: "SAT Physics",
            isPreselected: false,
          },
          {
            name: "SAT Literature",
            shortName: "SAT Literature",
            isPreselected: false,
          },
          {
            name: "SAT U.S. History",
            shortName: "SAT U.S. History",
            isPreselected: false,
          },
          {
            name: "SAT World History",
            shortName: "SAT History",
            isPreselected: false,
          },
          {
            name: "SAT French",
            shortName: "SAT French",
            isPreselected: false,
          },
          {
            name: "SAT German",
            shortName: "SAT German",
            isPreselected: false,
          },
          {
            name: "SAT Spanish",
            shortName: "SAT Spanish",
            isPreselected: false,
          },
          // {
          //   name: "SAT Latin",
          //   shortName: "SAT Latin",
          //   isPreselected: false,
          // },
          {
            name: "SAT Chinese",
            shortName: "SAT Chinese",
            isPreselected: false,
          },
        ],
      },
      {
        name: "IB - International Baccalaureate",
        description: "Preparation for IB exams",
        subjects: [
          {
            name: "IB Mathematics",
            shortName: "IB Math",
            isPreselected: true,
          },
          {
            name: "IB English",
            shortName: "IB English",
            isPreselected: true,
          },
          {
            name: "IB Biology",
            shortName: "IB Biology",
            isPreselected: false,
          },
          {
            name: "IB Chemistry",
            shortName: "IB Chemistry",
            isPreselected: false,
          },
          {
            name: "IB Physics",
            shortName: "IB Physics",
            isPreselected: false,
          },
          {
            name: "IB Economics",
            shortName: "IB Economics",
            isPreselected: false,
          },
          {
            name: "IB Geography",
            shortName: "IB Geography",
            isPreselected: false,
          },
          {
            name: "IB History",
            shortName: "IB History",
            isPreselected: false,
          },
          {
            name: "IB Computer Science",
            shortName: "IB Computer",
            isPreselected: false,
          },
        ],
      },
      {
        name: "AP - Advanced Placement Exam",
        description: "Preparation for AP programs",
        subjects: [
          {
            name: "AP Calculus",
            shortName: "AP Calculus",
            isPreselected: false,
          },
          {
            name: "AP English Language",
            shortName: "AP English",
            isPreselected: false,
          },
          {
            name: "AP Chemistry",
            shortName: "AP Chemistry",
            isPreselected: false,
          },
          {
            name: "AP Physics",
            shortName: "AP Physics",
            isPreselected: false,
          },
          {
            name: "AP Statistics",
            shortName: "AP Statistics",
            isPreselected: false,
          },
          {
            name: "AP English Literature",
            shortName: "AP Literature",
            isPreselected: false,
          },
          {
            name: "AP Geography",
            shortName: "AP Geography",
            isPreselected: false,
          },
          {
            name: "AP U.S. History",
            shortName: "AP U.S. History",
            isPreselected: false,
          },
          {
            name: "AP Computer Science",
            shortName: "AP Computer",
            isPreselected: false,
          },
          {
            name: "AP Music Theory",
            shortName: "AP Music",
            isPreselected: false,
          },
          {
            name: "AP Chinese",
            shortName: "AP Chinese",
            isPreselected: false,
          },
          {
            name: "AP German",
            shortName: "AP German",
            isPreselected: false,
          },
          {
            name: "AP Spanish",
            shortName: "AP Spanish",
            isPreselected: false,
          },
          // {
          //   name: "AP Latin",
          //   shortName: "AP Latin",
          //   isPreselected: false,
          // },
          {
            name: "AP French",
            shortName: "AP French",
            isPreselected: false,
          },
        ],
      },
    ],
  },
  "SSS 3": {
    purposes: [
      {
        name: "WAEC / UME / NECO / JUPEB",
        description: "Senior certificate examinations",
        subjects: [
          {
            name: "Mathematics",
            shortName: "SSS Math",
            isPreselected: false,
          },
          {
            name: "English Language",
            shortName: "SSS English",
            isPreselected: false,
          },
          {
            name: "Physics",
            shortName: "Physics",
            isPreselected: false,
          },
          {
            name: "Chemistry",
            shortName: "Chemistry",
            isPreselected: false,
          },
          {
            name: "Biology",
            shortName: "Biology",
            isPreselected: false,
          },
          {
            name: "Further Mathematics",
            shortName: "F/Math",
            isPreselected: false,
          },
          {
            name: "Economics",
            shortName: "Economics",
            isPreselected: false,
          },
          {
            name: "Accounting",
            shortName: "Accounting",
            isPreselected: false,
          },
          {
            name: "English Literature",
            shortName: "Literature",
            isPreselected: false,
          },
          {
            name: "Government",
            shortName: "Government",
            isPreselected: false,
          },
          {
            name: "Commerce",
            shortName: "Commerce",
            isPreselected: false,
          },
          {
            name: "Geography",
            shortName: "Geography",
            isPreselected: false,
          },
          {
            name: "History",
            shortName: "History",
            isPreselected: false,
          },
          {
            name: "Computer Science",
            shortName: "ICT",
            isPreselected: false,
          },
          {
            name: "Agricultural Science",
            shortName: "Agric. Science",
            isPreselected: false,
          },
          {
            name: "Technical Drawing",
            shortName: "Technical Drawing",
            isPreselected: false,
          },
        ],
      },
      {
        name: "IGCSE - Cambridge A/Levels",
        description: "Preparation for the IGCSEs",
        subjects: [
          {
            name: "IGCSE Mathematics",
            shortName: "IGCSE Math",
            isPreselected: false,
          },
          {
            name: "IGCSE English Language",
            shortName: "IGCSE English",
            isPreselected: false,
          },
          {
            name: "IGCSE English Literature",
            shortName: "IGCSE Literature",
            isPreselected: false,
          },
          {
            name: "IGCSE Biology",
            shortName: "IGCSE Biology",
            isPreselected: false,
          },
          {
            name: "IGCSE Chemistry",
            shortName: "IGCSE Chemistry",
            isPreselected: false,
          },
          {
            name: "IGCSE Physics",
            shortName: "IGCSE Physics",
            isPreselected: false,
          },
          {
            name: "IGCSE Geography",
            shortName: "IGCSE Geography",
            isPreselected: false,
          },
          {
            name: "IGCSE Spanish",
            shortName: "IGCSE Spanish",
            isPreselected: false,
          },
          {
            name: "IGCSE History",
            shortName: "IGCSE History",
            isPreselected: false,
          },
          {
            name: "IGCSE Computer Science",
            shortName: "IGCSE Computer",
            isPreselected: false,
          },
          {
            name: "IGCSE French",
            shortName: "IGCSE French",
            isPreselected: false,
          },
          {
            name: "IGCSE German",
            shortName: "IGCSE German",
            isPreselected: false,
          },
          {
            name: "IGCSE Business",
            shortName: "IGCSE Business",
            isPreselected: false,
          },
        ],
      },
      {
        name: "SAT / PSAT - Reasoning Test",
        description: "Math, Reading & Writing",
        subjects: [
          {
            name: "SAT Math",
            shortName: "SAT Math",
            isPreselected: true,
          },
          {
            name: "SAT Reading",
            shortName: "SAT Reading",
            isPreselected: true,
          },
          {
            name: "SAT Writing",
            shortName: "SAT Writing",
            isPreselected: true,
          },
        ],
      },
      {
        name: "ACT - College Test",
        description: "Math, English, Reading & Science",
        subjects: [
          {
            name: "ACT Mathematics",
            shortName: "ACT Math",
            isPreselected: true,
          },
          {
            name: "ACT English",
            shortName: "ACT English",
            isPreselected: true,
          },
          {
            name: "ACT Science",
            shortName: "ACT Science",
            isPreselected: true,
          },
          {
            name: "ACT Reading",
            shortName: "ACT Reading",
            isPreselected: true,
          },
          {
            name: "ACT Writing",
            shortName: "ACT Writing",
            isPreselected: false,
          },
        ],
      },
      {
        name: "Test of English Exams",
        description: "IELTS or TOEFL prep",
        subjects: [
          {
            name: "IELTS - International English Test",
            shortName: "IELTS",
            isPreselected: false,
          },
          {
            name: "TOEFL - Test of English",
            shortName: "TOEFL",
            isPreselected: false,
          },
          // {
          //   name: "PTE - Pearson Test of English",
          //   shortName: "PTE",
          //   isPreselected: false,
          // },
        ],
      },
      {
        name: "Edexcel - International A/Levels",
        description: "Pearson's Edexcel exam prep",
        subjects: [
          {
            name: "Edexcel Mathematics",
            shortName: "Edexcel Math",
            isPreselected: false,
          },
          {
            name: "Edexcel English",
            shortName: "Edexcel English",
            isPreselected: false,
          },
          {
            name: "Edexcel Chemistry",
            shortName: "Edexcel Chemistry",
            isPreselected: false,
          },
          {
            name: "Edexcel Economics",
            shortName: "Edexcel Economics",
            isPreselected: false,
          },
          {
            name: "Edexcel Biology",
            shortName: "Edexcel Biology",
            isPreselected: false,
          },
          {
            name: "Edexcel Physics",
            shortName: "Edexcel Physics",
            isPreselected: false,
          },
          {
            name: "Edexcel Accounting",
            shortName: "Edexcel Accounting",
            isPreselected: false,
          },
          {
            name: "Edexcel Applied ICT",
            shortName: "Edexcel ICT",
            isPreselected: false,
          },
          {
            name: "Edexcel Arabic Language",
            shortName: "Edexcel Arabic",
            isPreselected: false,
          },
          {
            name: "Edexcel Business Studies",
            shortName: "Edexcel Business",
            isPreselected: false,
          },
          {
            name: "Edexcel English Literature",
            shortName: "Edexcel Literature",
            isPreselected: false,
          },
          {
            name: "Edexcel French",
            shortName: "Edexcel French",
            isPreselected: false,
          },
          {
            name: "Edexcel Geography",
            shortName: "Edexcel Geography",
            isPreselected: false,
          },
          {
            name: "Edexcel German",
            shortName: "Edexcel German",
            isPreselected: false,
          },
          // {
          //   name: "Edexcel Greek",
          //   shortName: "Edexcel Greek",
          //   isPreselected: false,
          // },
          {
            name: "Edexcel History",
            shortName: "Edexcel History",
            isPreselected: false,
          },
          {
            name: "Edexcel Spanish",
            shortName: "Edexcel Spanish",
            isPreselected: false,
          },
        ],
      },
      {
        name: "SAT II - Subject Tests",
        description: "Prepare for SAT subject tests",
        subjects: [
          {
            name: "SAT Math Level I",
            shortName: "SAT Math I",
            isPreselected: false,
          },
          {
            name: "SAT Math Level II",
            shortName: "SAT Math II",
            isPreselected: false,
          },
          {
            name: "SAT Biology",
            shortName: "SAT Biology",
            isPreselected: false,
          },
          {
            name: "SAT Chemistry",
            shortName: "SAT Chemistry",
            isPreselected: false,
          },
          {
            name: "SAT Physics",
            shortName: "SAT Physics",
            isPreselected: false,
          },
          {
            name: "SAT Literature",
            shortName: "SAT Literature",
            isPreselected: false,
          },
          {
            name: "SAT U.S. History",
            shortName: "SAT U.S. History",
            isPreselected: false,
          },
          {
            name: "SAT World History",
            shortName: "SAT History",
            isPreselected: false,
          },
          {
            name: "SAT French",
            shortName: "SAT French",
            isPreselected: false,
          },
          {
            name: "SAT German",
            shortName: "SAT German",
            isPreselected: false,
          },
          {
            name: "SAT Spanish",
            shortName: "SAT Spanish",
            isPreselected: false,
          },
          // {
          //   name: "SAT Latin",
          //   shortName: "SAT Latin",
          //   isPreselected: false,
          // },
          {
            name: "SAT Chinese",
            shortName: "SAT Chinese",
            isPreselected: false,
          },
        ],
      },
      {
        name: "IB - International Baccalaureate",
        description: "Preparation for IB exams",
        subjects: [
          {
            name: "IB Mathematics",
            shortName: "IB Math",
            isPreselected: true,
          },
          {
            name: "IB English",
            shortName: "IB English",
            isPreselected: true,
          },
          {
            name: "IB Biology",
            shortName: "IB Biology",
            isPreselected: false,
          },
          {
            name: "IB Chemistry",
            shortName: "IB Chemistry",
            isPreselected: false,
          },
          {
            name: "IB Physics",
            shortName: "IB Physics",
            isPreselected: false,
          },
          {
            name: "IB Economics",
            shortName: "IB Economics",
            isPreselected: false,
          },
          {
            name: "IB Geography",
            shortName: "IB Geography",
            isPreselected: false,
          },
          {
            name: "IB History",
            shortName: "IB History",
            isPreselected: false,
          },
          {
            name: "IB Computer Science",
            shortName: "IB Computer",
            isPreselected: false,
          },
        ],
      },
      {
        name: "AP - Advanced Placement Exam",
        description: "Preparation for AP programs",
        subjects: [
          {
            name: "AP Calculus",
            shortName: "AP Calculus",
            isPreselected: false,
          },
          {
            name: "AP English Language",
            shortName: "AP English",
            isPreselected: false,
          },
          {
            name: "AP Chemistry",
            shortName: "AP Chemistry",
            isPreselected: false,
          },
          {
            name: "AP Physics",
            shortName: "AP Physics",
            isPreselected: false,
          },
          {
            name: "AP Statistics",
            shortName: "AP Statistics",
            isPreselected: false,
          },
          {
            name: "AP English Literature",
            shortName: "AP Literature",
            isPreselected: false,
          },
          {
            name: "AP Geography",
            shortName: "AP Geography",
            isPreselected: false,
          },
          {
            name: "AP U.S. History",
            shortName: "AP U.S. History",
            isPreselected: false,
          },
          {
            name: "AP Computer Science",
            shortName: "AP Computer",
            isPreselected: false,
          },
          {
            name: "AP Music Theory",
            shortName: "AP Music",
            isPreselected: false,
          },
          {
            name: "AP Chinese",
            shortName: "AP Chinese",
            isPreselected: false,
          },
          {
            name: "AP German",
            shortName: "AP German",
            isPreselected: false,
          },
          {
            name: "AP Spanish",
            shortName: "AP Spanish",
            isPreselected: false,
          },
          // {
          //   name: "AP Latin",
          //   shortName: "AP Latin",
          //   isPreselected: false,
          // },
          {
            name: "AP French",
            shortName: "AP French",
            isPreselected: false,
          },
        ],
      },
    ],
  },
};

export type AcademicDataType = typeof ACADEMICS_DATA;
